import { isSellable } from "./catalog.js";
import { addCents, cents, mulCents } from "./money.js";
import { deliveryFeeForKm } from "./delivery.js";
/** Wholesale buys by the crate, so its stepper moves six at a time. */
export const STEP = { retail: 1, wholesale: 6 };
export function setQty(lines, product, qty) {
    if (!Number.isInteger(qty) || qty < 0)
        throw new RangeError(`setQty: bad qty: ${qty}`);
    if (!isSellable(product) && qty > 0) {
        return { lines: without(lines, product.code) };
    }
    const capped = Math.min(qty, product.stock);
    const next = capped === 0 ? without(lines, product.code) : { ...lines, [product.code]: capped };
    return capped === qty ? { lines: next } : { lines: next, clampedTo: capped };
}
export function bump(lines, product, direction, channel) {
    const step = STEP[channel];
    const current = lines[product.code] ?? 0;
    return setQty(lines, product, Math.max(0, current + direction * step));
}
function without(lines, code) {
    if (!(code in lines))
        return lines;
    const next = { ...lines };
    delete next[code];
    return next;
}
/**
 * Prices a cart against the catalog as it stands right now. Lines whose
 * product has vanished or sold out are dropped rather than guessed at, so a
 * cart left open overnight cannot bill for milk that no longer exists.
 */
export function priceCart(input) {
    const index = new Map(input.catalog.map((p) => [p.code, p]));
    const priced = [];
    for (const [code, qty] of Object.entries(input.lines)) {
        const product = index.get(code);
        if (!product || !isSellable(product) || qty <= 0)
            continue;
        const usable = Math.min(qty, product.stock);
        priced.push({ product, qty: usable, lineTotal: mulCents(product.price, usable) });
    }
    priced.sort((a, b) => b.lineTotal - a.lineTotal);
    const subtotal = addCents(...priced.map((l) => l.lineTotal));
    const delivery = deliveryFeeForKm({
        channel: input.channel,
        km: input.km,
        subtotal,
    });
    return {
        lines: priced,
        bottles: priced.reduce((a, l) => a + l.qty, 0),
        subtotal,
        delivery,
        total: addCents(subtotal, delivery),
    };
}
/**
 * A past order back in the basket. Milk is a weekly buy; this is the one
 * tap that makes the second order faster than the first. Quantities are
 * clamped to today's stock and anything no longer sold is dropped.
 */
export function linesForReorder(past, catalog) {
    const index = new Map(catalog.map((p) => [p.code, p]));
    let lines = {};
    for (const line of past) {
        const product = index.get(line.code);
        if (!product)
            continue;
        lines = setQty(lines, product, line.qty).lines;
    }
    return lines;
}
export const EMPTY_TOTALS = {
    lines: [],
    bottles: 0,
    subtotal: cents(0),
    delivery: cents(0),
    total: cents(0),
};
//# sourceMappingURL=cart.js.map